import { cn } from "../../lib/cn.js";

/**
 * A plain two-div progress bar. No Radix here for the same reason `select.tsx` is a
 * native element: the whole job is "a track and a fill", and a dependency would buy
 * nothing but a portal it does not need.
 */
export function Progress({
  value,
  className,
}: {
  /** 0–100; anything outside is clamped rather than drawn off the track. */
  readonly value: number;
  readonly className?: string;
}): React.JSX.Element {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
      className={cn("bg-muted h-1.5 w-full overflow-hidden rounded-full", className)}
    >
      <div className="bg-primary h-full rounded-full transition-[width] duration-500" style={{ width: `${String(clamped)}%` }} />
    </div>
  );
}
